import { getMediaOrigin } from '../../utils/media';

export type TrendingVideo = {
  id: string;
  productFocus: string;
  contentLink: string;
  productLink: string;
  videoPath: string;
  videoUrl: string;
};

const getVideoUrl = (path: string): string => `${getMediaOrigin()}${path}`;

export const TRENDING_VIDEOS: TrendingVideo[] = [
  {
    id: '1',
    productFocus: 'IOPE Gluta Vitamin C Toning Ampoule',
    contentLink: 'https://www.instagram.com/p/DIyZQz2zXJO/',
    productLink: 'https://skin-seoul.com/product/iope-gluta-vitamin-c-toning-ampoule/',
    videoPath: '/short/SnapInsta-Ai_3617064557086601806.mp4',
  },
  {
    id: '2',
    productFocus: 'Nooni Snow Aqua 0 LHA Toning Cleansing Oil',
    contentLink: 'https://www.instagram.com/reel/DH0cGhhzaMh/',
    productLink: 'https://skin-seoul.com/product/snow-aqua-0-lha-toning-cleansing-oil-200ml-1ea/',
    videoPath: '/short/SnapInsta-Ai_3599625595795645217.mp4',
  },
  {
    id: '4',
    productFocus: 'Dr. Jart Intensive Soothing Cicapair Repair Cream',
    contentLink: 'https://www.instagram.com/p/DIQw3fLznKf/',
    productLink: 'https://skin-seoul.com/product/dr-jart-cicapair-intensive-soothing-repair-cream-50ml-1-pack/',
    videoPath: '/short/SnapInsta-Ai_3607598220811596447.mp4',
  },
  {
    id: '5',
    productFocus: 'Laneige Lip Sleeping Mask',
    contentLink: 'https://www.instagram.com/p/DIgNo0QRSD3/',
    productLink: 'https://skin-seoul.com/product/laneige-lip-sleeping-mask-ex-mint-choco/',
    videoPath: '/short/SnapInsta-Ai_3611946880642392311.mp4',
  },
  {
    id: '6',
    productFocus: 'Dr. G Mild Up Sun Plus SPF50+ PA++++',
    contentLink: 'https://www.tiktok.com/@skinseoul.official/video/7441223033118870791',
    productLink: 'https://skin-seoul.com/product/drg-green-mild-up-sun-plus-spf50-pa/',
    videoPath: '/short/100006885+Green+Mild+Up+Sun+Plus.mp4',
  },
  {
    id: '7',
    productFocus: 'Wellage Real Hyaluronic 100 Cream',
    contentLink: 'https://www.tiktok.com/@skinseoul.official/video/7486082934714191112',
    productLink: 'https://skin-seoul.com/product/wellage-real-hyaluronic-100-cream/',
    videoPath: '/short/snaptik_7486082934714191112_v2.mp4',
  },
  {
    id: '8',
    productFocus: 'Nooni Daily Turnover Peel Pad',
    contentLink: 'https://www.tiktok.com/@ohwowitsjenny/video/7484359801967840534',
    productLink: 'https://skin-seoul.com/product/nooni-daily-turnover-peel-pad-80ea-1pack/',
    videoPath: '/short/100006709+Daily+Turnover+Peel+Pad.mp4',
  },
  {
    id: '10',
    productFocus: 'SKIN 1004 Madagascar Centella Hyalu-Cica Water-Fit Sun Serum',
    contentLink: 'https://www.instagram.com/reel/DHf1Ju1RIX0/',
    productLink: 'https://skin-seoul.com/product/madagascar-centella-hyalu-cica-water-fit-sun-serum-100ml/',
    videoPath: '/short/SnapInsta-Ai_3593824792891131380.mp4',
  },
  {
    id: '11',
    productFocus: 'CKD Retino Collagen Gua Sha Neck Wrinkle Cream',
    contentLink: 'https://www.tiktok.com/@skinseoul.official/video/7489038388310363410',
    productLink: 'https://skin-seoul.com/product/ckd-retino-collagen-gua-sha-neck-wrinkle-cream-50ml/',
    videoPath: '/short/snaptik_7489038388310363410_v2.mp4',
  },
  {
    id: '12',
    productFocus: 'SNP Gold & Collagen Firming Eye Patches',
    contentLink: 'https://www.tiktok.com/@skinseoul.official/video/7427861150378773768',
    productLink: 'https://skin-seoul.com/product/snp-gold-collagen-firming-eye-patch/',
    videoPath: '/short/100004299+Gold+%26+Collagen+Firming+Eye+Patch.mp4',
  },
  {
    id: '15',
    productFocus: 'Anua Heartleaf 77 Clear Toner Pads',
    contentLink: 'https://www.tiktok.com/@skinseoul.official/video/7421125626108611848',
    productLink: 'https://skin-seoul.com/product/anua-heartleaf-77-clear-pad/',
    videoPath: '/short/100004983+Heartleaf+77+Clear+Pad.mp4',
  },
  {
    id: '17',
    productFocus: 'Oligo Hyaluronic Acid Deep Toner',
    contentLink: 'https://www.tiktok.com/@skinseoul.official/video/7418182773548141831',
    productLink:
      'https://skin-seoul.com/product/the-lab-by-blanc-doux-oligo-hyaluronic-acid-low-molecular-deep-toner-300ml/',
    videoPath: '/short/snaptik_7418182773548141831_v2.mp4',
  },
  {
    id: '18',
    productFocus: 'S.NATURE Aqua Squalane Moisturizing Cream',
    contentLink: 'https://www.instagram.com/reel/DFr-qz0Mvm_/',
    productLink: 'https://skin-seoul.com/product/s-nature-aqua-squalane-moisturizing-cream/',
    videoPath: '/short/SnapInsta-Ai_3561215551104809407.mp4',
  },
  {
    id: '20',
    productFocus: 'KAHI Wrinkle Bounce Multi Balm',
    contentLink: 'https://www.instagram.com/reel/DFm004HM24c/',
    productLink: 'https://skin-seoul.com/product/kahi-wrinkle-bounce-multi-balm/',
    videoPath: '/short/SnapInsta-Ai_3559764887564676636.mp4',
  },
  {
    id: '21',
    productFocus: 'Dr. G Brightening Peeling Gel',
    contentLink: 'https://www.instagram.com/reel/DFxKP2nMuUV/',
    productLink: 'https://skin-seoul.com/product/dr-g-brightening-peeling-gel/',
    videoPath: '/short/SnapInsta-Ai_3562673850123740437.mp4',
  },
].map((video) => ({
  ...video,
  videoUrl: getVideoUrl(video.videoPath),
}));
